<template>
  <v-container>
    <v-layout justify-center>
      <v-flex>
        <v-card class="elevation-12 mb-8" :loading="loading">

          <v-app-bar dark color="primary">
            <h3>{{ $t('messages.headline')}}</h3>
          </v-app-bar>

          <v-list two-line>
            <v-list-item v-for="message in messages" :key="message.id">
              <v-list-item-content>
                <v-list-item-title>{{message.message.title}}</v-list-item-title>
                <v-list-item-subtitle class="text-wrap">{{message.message.text}}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-list-item-action-text>{{message.message.sent_at | moment('DD.MM.YYYY HH:mm')}}</v-list-item-action-text>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <div v-if="showNoMessagesHint" class="text-center body-2 pb-3">
            {{ $t('messages.noMessages') }}
          </div>

        </v-card>
      </v-flex>
    </v-layout>
    <push-notification-request />
  </v-container>
</template>

<script>
  import {BASE_API_URL} from '@/store'
  import PushNotificationRequest from '@/components/utils/PushNotificationRequest'

  export default {
    name: 'Messages',
    components: {PushNotificationRequest},
    data() {
      return {
        messages: [],
        showNoMessagesHint: false,
        loading: false
      };
    },
    mounted() {
      this.fetchMessages();
    },
    methods: {
      async fetchMessages() {
        this.loading = true;
        try {
          let response = await this.axios.get(`${BASE_API_URL}/api/v1/messaging/`);
          if (response.data && response.data.length) {
            this.messages = response.data;
          } else {
            this.showNoMessagesHint = true;
          }
        } catch (err) {
          console.error('Error fetching messages. ', err)
          this.showNoMessagesHint = true;
        } finally {
          this.loading = false;
        }
      }
    }
  };
</script>

<style scoped lang="scss">
  .v-card::v-deep .v-card__progress .v-progress-linear__background {
    background-color: grey !important;
  }
</style>
